module.exports = __webpack_public_path__ + "img/Carousel6.fcfee393.jpg";